import { render } from "./icon-checkmark-circle.svg?vue&type=template&id=5892408f"
const script = {}

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__